import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReferrerStatisticsState, ReferrerStatistics } from './ReferrerStatistics.types';

const initialState: ReferrerStatisticsState = {
    data: {
        totalEarnings: 0,
        referralCount: 0,
    },
    requestStatus: 'initial',
    error: undefined,
};

const referrerStatisticsSlice = createSlice({
    name: 'referralStatistics',
    initialState,
    reducers: {
        fetchReferrerStatisticsStarted: (state) => {
            state.requestStatus = 'pending';
            state.error = undefined;
        },
        fetchReferrerStatisticsSucceeded: (state, action: PayloadAction<ReferrerStatistics>) => {
            state.data = action.payload;
            state.requestStatus = 'resolved';
        },
        fetchReferrerStatisticsFailed: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.requestStatus = 'rejected';
        },
        resetReferrerStatistics: (state) => {
            state.data = {
                totalEarnings: 0,
                referralCount: 0,
            };
            state.requestStatus = 'initial';
            state.error = undefined;
        },
    },
});

export const {
    fetchReferrerStatisticsStarted,
    fetchReferrerStatisticsSucceeded,
    fetchReferrerStatisticsFailed,
    resetReferrerStatistics,
} = referrerStatisticsSlice.actions;

export default referrerStatisticsSlice.reducer;
